import type {ReactElement, ReactNode} from 'react';
import {createContext, type Reducer, useReducer} from 'react';
import type ReducerAction from '@interfaces/context';
import type {BalanceContext, BalanceState, SetIsUpdatingReducerAction} from '@interfaces/balance';

interface Props {
    children: ReactNode;
}

const actions = {
    setIsUpdating: 'setIsUpdating',
};

const initialState: BalanceState = {
    isUpdating: false,
};

const store = createContext<BalanceContext>({
    currentState: initialState,
    dispatch: () => {
        /* do nothing */
    },
});
const {Provider} = store;

const reducer: Reducer<BalanceState, ReducerAction> = (state, action) => {
    switch (action.type) {
        case actions.setIsUpdating:
            return {
                ...state,
                ...(action as SetIsUpdatingReducerAction).data,
            };
        default:
            throw new Error('Unknown action');
    }
};

const StateProvider = function ({children}: Props): ReactElement<Props> {
    const [currentState, dispatch] = useReducer(reducer, {...initialState});
    return <Provider value={{currentState, dispatch}}>{children}</Provider>;
};

export {store, StateProvider, actions};
